import { render, staticRenderFns } from "./DashboardPremiumSummaryView.vue?vue&type=template&id=5f1d70f4&"
import script from "./DashboardPremiumSummaryView.vue?vue&type=script&lang=ts&"
export * from "./DashboardPremiumSummaryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports